import React from "react";
import { Link } from "react-router-dom";
import { CalendarClock, ArrowRight } from "lucide-react";

export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      role="region"
      aria-label="November batch pre-order announcement"
      className="w-full"
      style={{ background: "#060504", color: "#FCF6EA", borderBottom: "1px solid rgba(255,122,26,0.55)" }}
    >
      <Link
        to="/products/CORE-500"
        data-testid="announcement-bar-link"
        className="max-w-[1400px] mx-auto px-4 md:px-12 py-2.5 flex items-center justify-center gap-2.5 text-center text-xs sm:text-sm leading-snug hover:opacity-90 transition-opacity"
      >
        <CalendarClock size={15} className="flex-shrink-0" style={{ color: "var(--sun-amber)" }} />
        <span>
          <span className="hidden sm:inline"><span className="font-medium">Next production batch lands in November.</span>{" "}<span style={{ color: "rgba(252,246,234,0.82)" }}>Pre-order your CORE 500 now to guarantee delivery.</span></span>
          <span className="sm:hidden"><span className="font-medium">November batch</span> <span style={{ color: "rgba(252,246,234,0.82)" }}>— pre-order now to guarantee delivery.</span></span>
        </span>
        <ArrowRight size={14} className="flex-shrink-0 hidden sm:block" style={{ color: "var(--sun-orange)" }} />
      </Link>
    </div>
  );
}
